<rt-dropdown [width]="DropdownWidth.FullWidth" (click)="$event.preventDefault()">
  <rt-dropdown-header>
    {{ 'rtu.interview.schedule_dialog.timezone' | translate }}
  </rt-dropdown-header>
  <rt-time-zone-picker-dropdown-list (zoneSelect)="zoneSelect.emit($event)">
  </rt-time-zone-picker-dropdown-list>
</rt-dropdown>
